module.exports = "/* Spinner */\r\n.spinner {\r\n  font-size:300%;\r\n  position:absolute;\r\n  top: 46%;\r\n  left: 46%;\r\n  z-index:10\r\n}"